/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import * as Joi from 'joi-browser';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { FormControlLabel } from '@material-ui/core';
import FormLabel from '@material-ui/core/FormLabel';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import ReCAPTCHA from 'react-google-recaptcha';
import mbpUtil from 'mbp-api-util';
import { isEmpty } from '../utils/object';
import ErrorLanguages from './ErrorMessages/ErrorLanguages';
import MaskInput from './ModalContent/InputMask/InputMask'
import { getCityStateFromZip } from '../../../helpers/checkCityStateZip';

class Form extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            errors: {},
            zipUpdated: false,
        };
    }


    async componentDidUpdate() {
        const zipCode = this.state?.data?.zipcode || '';
        const needsQASCheck = !zipCode.match(/[A-Za-z]/) && (zipCode.length === 5 || zipCode.match(/^\d{5}(?:-\d{4})?$/));
        if (needsQASCheck && !this.state.zipUpdated) {
            const hasErrorMessage = await getCityStateFromZip(zipCode);
            if (hasErrorMessage) {
                this.setState({ ...this.state, errors: { zipcode: 'Invalid Zip Code' }, zipUpdated: true });
            }
        }
    }

    removeMaskForPhoneNumber = (number) => {
        let strNumber = number.toString().trim();
        strNumber = strNumber.replace(/\s/g, '').replace(/[^0-9+]/g, '');
        if (strNumber.indexOf('+') === 0 && strNumber.indexOf('1') === 1) {
            strNumber = strNumber.substring(2, strNumber.length);
        } else if (strNumber.indexOf('+') >= 0) {
            strNumber = strNumber.replace(/\s/g, '').replace(/[^0-9]/g, '');
        }
        return strNumber;
    };

    validate = (isBoolean = false) => {
        const options = { abortEarly: false };
        const { data, consoleErrorValidation } = this.state;

        if (data.phone) {
            const phoneUnMask = this.removeMaskForPhoneNumber(data.phone);
            data.phone = phoneUnMask;
        }

        const { error } = Joi.validate(data, this.schema, options);
        if (!error) {
            if (!isBoolean) return {};
            return true;
        }
        if (consoleErrorValidation) {
            console.log(error);
        }
        const errors = {};
        error.details.forEach((element) => {
            if (typeof errors[element.path[0]] === 'undefined') {
                errors[element.path[0]] = element.message;
            }
        });
        if (!isBoolean) return errors;
        if (isEmpty(errors)) return true;
        return false;
    };

    validateProperty = ({ name, value }) => {
        // name propety is required to validate the schema
        if (!name) return null;
        const obj = { [name]: value };
        const schema = { [name]: this.schema[name] };
        const { data, consoleErrorValidation } = this.state;
        // eslint-disable-next-line no-underscore-dangle
        const { _refs } = this.schema[name];
        if (_refs && data[_refs[0]] === value) {
            return null;
        }
        const { error } = Joi.validate(obj, schema);
        if (consoleErrorValidation) {
            console.log('ValidateProperty', error);
        }
        return error ? error.details[0].message : null;
    };

    handleSubmit = (e, submitData) => {
        e.preventDefault();
        /* eslint no-underscore-dangle: ["error", { "allow": ["__target__"] }] */
        if (e.__target__) {
            this.doSubmit(submitData, e.__target__);
            return;
        }

        const errors = this.validate();
        this.setState({ errors: errors || {} });

        if (!isEmpty(errors)) return;

        this.doSubmit(submitData);
    };

    handleCheckboxChange = (event) => {
        const { data } = this.state;
        data[event.target.value] = event.target.checked;
        this.setState({ data });
    };

    handleChangeRecap = (value, handleChangeRecap) => {
        const { data, errors } = this.state;
        const newInput = {};
        newInput.name = 'recaptcha';
        newInput.value = 'recaptcha';
        const errorMessage = this.validateProperty(newInput);
        if (errorMessage) errors[newInput.name] = errorMessage;
        else delete errors[newInput.name];
        data[newInput.name] = newInput.value;

        this.setState({ data, errors }, () => {
            /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
            try {
                this.doChange(data);
            } catch (ex) { }
            /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
            try {
                handleChangeRecap(data);
            } catch (ex) { }
        });
    }

    handleChange = (
        { currentTarget: input, __target__ },
        pattern,
        onChangeHandler,
    ) => {
        // eslint-disable-next-line object-curly-newline
        const { data, errors, replaceMask, replaceMaskWith } = this.state;
        const regexPattern = new RegExp(pattern);
        const target = __target__
            && typeof __target__.value !== 'undefined'
            && typeof __target__.name !== 'undefined'
            ? __target__
            : input;
        if (typeof target === 'undefined') return;

        const newInput = {};
        newInput.name = typeof target.getAttribute === 'function'
            && target.getAttribute('name')
            ? target.getAttribute('name')
            : target.name;

        // Prevent error while clicking outside the input field
        if (!newInput.name) return;

        newInput.value = typeof target.getAttribute === 'function'
            && target.getAttribute('data-value')
            ? target.getAttribute('data-value')
            : target.value;
        // Get selectUI name
        const { nextSibling } = target;
        if (nextSibling && nextSibling.tagName === 'INPUT' && nextSibling.type === 'hidden') {
            if (typeof newInput.name === 'undefined') {
                newInput.name = nextSibling.name;
            }
            if (typeof newInput.value === 'undefined') {
                newInput.value = nextSibling.value;
            }
        }
        if (
            typeof newInput.value === 'string'
            && replaceMask
            && replaceMask[newInput.name]
            && replaceMaskWith
            && typeof replaceMaskWith[newInput.name] !== 'undefined'
        ) {
            if (replaceMaskWith[newInput.name] === 'toUpperCase') {
                newInput.value = newInput.value.toUpperCase();
            } else {
                newInput.value = newInput.value.replace(
                    new RegExp(replaceMask[newInput.name], 'g'),
                    replaceMaskWith[newInput.name],
                );
            }
        }

        if (newInput.value && pattern && !regexPattern.test(newInput.value)) {
            return;
        }

        if (newInput.name === 'zipcode') {
            this.setState({ zipUpdated: false });
        }


        let errorMessage = this.validateProperty(newInput);

        if (errorMessage) {
            if (newInput.name === 'zipcode' && newInput.value.length !== 0) {
                errorMessage = "Invalid Zip Code";
            }
            errors[newInput.name] = errorMessage;
        }
        else delete errors[newInput.name];
        data[newInput.name] = newInput.value;
        this.setState({ data, errors }, () => {
            /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
            try {
                this.doChange(data);
            } catch (ex) { }
            /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
            try {
                onChangeHandler(data);
            } catch (ex) { }
        });
    };

    handleEventListener = (
        { currentTarget },
        name,
        onEventHandler,
    ) => {
        const input = currentTarget.querySelector(`input[name="${name}"]`);
        if (input && onEventHandler) {
            /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
            try {
                onEventHandler(input);
            } catch (ex) { }
        }
    };

    handleClickShowPassword = (name) => {
        const { showPassword } = this.state;
        showPassword[name] = !showPassword[name];
        this.setState({ showPassword });
    };

    renderButton(props) {
        const {
            label,
            className,
            dataTest = null,
            onClick,
            type,
            waitingLabel = '',
            isValidated = true,
            isReadyState = true,
        } = props;
        let dataTestField = null;
        const hasErrors = !!Object.keys(this.state?.errors)?.length > 0 && !label?.includes('Cancel');
        if (dataTest) {
            dataTestField = { 'data-test': dataTest.field };
        }
        // const onClickEvent = type === 'submit' ? this.handleSubmit : onClick;
        let isDisabled = isValidated ? !this.validate(true) : false;
        isDisabled = !isReadyState || isDisabled;
        return (
            <Button
                disabled={isDisabled || hasErrors}
                onClick={onClick}
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...dataTestField}
                className={className}
                type={type}
            >
                {waitingLabel || label}
            </Button>
        );
    }

    renderInput(props) {
        const {
            name,
            label,
            type = 'text',
            dataTest = null,
            pattern = '',
            length = 100,
            minLength = null,
            desktop = false,
            placeholder = '',
            adornment = '',
            adornmentPosition = 'end',
            mask = {},
            customProps = {},
            onChangeHandler = '',
            customClass = '',
            onKeyupHandler = '',
            onKeypressHandler = '',
            onClickHandler = '',
            onKeydownHandler = '',
            autoComplete = '',
            disabled = false,
        } = props;
        let dataTestLabel = null;
        let dataTestField = null;
        if (dataTest) {
            dataTestLabel = { 'data-test': dataTest.label };
            dataTestField = { 'data-test': dataTest.field };
        }
        const { data, errors, showPassword } = this.state;
        const InputProps = {};

        const errorMessage = ErrorLanguages(errors[name]);
        const isError = typeof errorMessage !== 'undefined';
        let output = null;
        let CustomTextField = null;
        let hasAdorment = '';

        if (!isEmpty(mask)) {
            InputProps.inputComponent = mask;
        }

        // Phone Number
        if (name === 'phone') {
            const maskedPhone = MaskInput.Phone(data[name]);
            data[name] = maskedPhone.maskInputVal;
        }

        // Expiration Date
        if (name === 'expiration') {
            const maskedExpDate = MaskInput.ExpirationDate(data[name]);
            data[name] = maskedExpDate;
        }

        // ZipCode
        if (name === 'zipcode') {
            const maskedZipCode = MaskInput.ZipCode(data.country, data[name])
            data[name] = maskedZipCode
        }

        if (/^(start|end)$/.test(adornmentPosition)) {
            if (type === 'password' && showPassword) {
                InputProps.endAdornment = (
                    <InputAdornment className="input-adorment end" position="end">
                        <IconButton
                            className="adornment-button"
                            aria-label="Toggle password visibility"
                            onClick={() => this.handleClickShowPassword(name)}
                        >
                            {showPassword[name] ? (
                                'Hide'
                            ) : (
                                'Show'
                            )}
                        </IconButton>
                    </InputAdornment>
                );
            } else if (adornment) {
                if (adornmentPosition === 'end') {
                    hasAdorment = 'end';
                    InputProps.endAdornment = (
                        <InputAdornment className={desktop === true ? 'desktop-adorment-end' : 'input-adorment end'} position={adornmentPosition}>{adornment}</InputAdornment>
                    );
                } else {
                    hasAdorment = 'start';
                    InputProps.startAdornment = (
                        <InputAdornment className={desktop === true ? 'desktop-adorment-start' : 'input-adorment start'} position={adornmentPosition}>{adornment}</InputAdornment>
                    );
                }
            }
        }
        if (desktop) {
            CustomTextField = (
                <div id={name} className={hasAdorment ? `has-desktop-adorment-${hasAdorment}` : 'input-password-width field' }>
                    {label && <FormLabel className="label-style" component="legend" aria-label={`please enter ${label}`}>
                        {label}
                    </FormLabel>}
                    <TextField
                        name={name}
                        value={data[name]}
                        fullWidth
                        variant="outlined"
                        className="desktop-field"

                        type={showPassword && showPassword[name] ? 'text' : type}
                        inputProps={{
                            maxLength: length,
                            minLength,
                            ...dataTestField,
                            placeholder,
                            autoComplete,
                            disabled,
                            className: `input-field text-field-input ${customClass} ${isError ? 'borderErrorColor' : ''}`,
                            classes: { focused: 'focused' },
                            'data-props': customProps,
                            'aria-labelledby': name,
                        }}
                        // Need to disable eslint below because it counts the 'inputProps' and 'InputProps' as the same attribute
                        // eslint-disable-next-line
                        InputProps={InputProps}
                        InputLabelProps={
                            {
                                classes: {
                                    root: `input-label ${isError ? 'error' : ''}`,
                                },
                            }
                        }
                        onChange={(event) => this.handleChange(event, pattern, onChangeHandler)}
                        onKeyUp={(event) => this.handleEventListener(event, name, onKeyupHandler)}
                        onKeyPress={(event) => this.handleEventListener(event, name, onKeypressHandler)}
                        onKeyDown={(event) => this.handleEventListener(event, name, onKeydownHandler)}
                        onBlur={(event) => this.handleChange(event, pattern, onChangeHandler)}
                        onClick={(event) => this.handleEventListener(event, name, onClickHandler)}
                        error={isError}
                        helperText={errorMessage}
                        FormHelperTextProps={
                            {
                                classes: {
                                    root: `desktop-helper-text ${isError ? 'error' : ''} ${name === 'cardholder' && 'helper-text-cardholder'}`,
                                },
                            }
                        }
                    />
                </div>
            );
        } else {
            CustomTextField = (
                <div className={hasAdorment ? `has-mobile-adorment-${hasAdorment}` : (label === 'First Name of Deceased' || label === 'Last Name of Deceased') ? 'text-field-hide-overflow' : ''}>
                    <TextField
                        className="text-field-wrapper"
                        name={name}
                        value={data[name]}
                        label={label}
                        fullWidth
                        type={showPassword && showPassword[name] ? 'text' : type}
                        // eslint-disable-next-line object-curly-newline
                        inputProps={{
                            maxLength: length,
                            minLength,
                            ...dataTestField,
                            placeholder,
                            autoComplete,
                            disabled,
                            className: `input-field ${customClass}`,
                            'data-props': customProps,
                            'aria-labelledby': name,
                        }}
                        // eslint-disable-next-line
                        InputProps={InputProps}
                        InputLabelProps={
                            {
                                classes: {
                                    root: `input-label ${isError ? 'error' : ''}`,
                                },
                                ...dataTestLabel,
                                'aria-label': `please enter ${label || name}`,
                            }
                        }
                        onChange={(event) => this.handleChange(event, pattern, onChangeHandler)}
                        onKeyUp={(event) => this.handleEventListener(event, name, onKeyupHandler)}
                        onKeyPress={(event) => this.handleEventListener(event, name, onKeypressHandler)}
                        onBlur={(event) => this.handleChange(event, pattern, onChangeHandler)}
                        onClick={(event) => this.handleEventListener(event, name, onClickHandler)}
                        error={isError}
                        helperText={errorMessage}
                        FormHelperTextProps={
                            {
                                classes: {
                                    root: `form-helper-text ${isError ? 'error' : ''}`,
                                },
                            }
                        }
                    />
                </div>
            );
        }
        output = CustomTextField;
        if (/^icon-start$/.test(adornmentPosition)) {
            output = (
                <div className="split align-bottom">
                    <div className="flex-none no-padding margin-right-half margin-bottom-left-icon">
                        {adornment}
                    </div>
                    <div>
                        {CustomTextField}
                    </div>
                </div>
            );
        }

        return output;
    }

    renderSelect(props) {
        const {
            name,
            label,
            options,
            onChangeHandler = '',
            useIDAsLabel = false,
            desktop = false,
            classes,
            cardTypeIcon,
            addressBookSelect = false,
        } = props;
        const { data, errors } = this.state;
        if (!options) return null;
        const errorMessage = ErrorLanguages(errors[name]);
        const isError = typeof errorMessage !== 'undefined';
        let output = null;
        if (desktop) {
            output = (
                <FormControl
                    className="full-width field"
                    error={isError}
                >
                    {label && <FormLabel
                        htmlFor={`select-${name}`}
                        className="label-style"
                        component="legend"
                        aria-label={`please select ${label}`}
                    >
                        {label}
                    </FormLabel>}
                    <Select
                        name={name}
                        value={data[name]}
                        fullWidth
                        disableUnderline
                        onChange={(event) => this.handleChange(event, '', onChangeHandler)}
                        onBlur={(event) => this.handleChange(event, '', onChangeHandler)}
                        error={isError}
                        inputProps={{
                            id: `select-${name}`,
                            className: `input-field text-field-input select-input underline ${isError ? 'borderErrorColor' : ''} `,
                            classes: {
                                icon: 'select-icon ',
                            },
                            'data-test': `account-select-field-${name}`,
                            'aria-labelledby': name,
                        }}
                        SelectDisplayProps={{
                            'data-test': `account-select-field-clickable-div-${name}`,    // do NOT change or remove data-test attribute
                        }}
                        MenuProps={{
                            style: { maxHeight: addressBookSelect ? 400 : 'unset' },
                            anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left',
                            },
                        }}
                        className={cardTypeIcon ? classes?.cardTypeIcon : ''}
                    >
                        {options.map((option) => {
                            const CardTypeIcon = option.icon;
                            return (
                                <MenuItem
                                    key={option.id}
                                    name={name}
                                    data-test={`${'my-account-field-'}${name}${'-value-'}${useIDAsLabel ? option.id : option.name}`}
                                    value={option.id}
                                    ContainerProps={{ name }}
                                    className={cardTypeIcon ? classes?.menuIcon : ''}
                                >
                                    {(cardTypeIcon && option.icon)
                                        && (
                                            <>
                                                <ListItemText primary={useIDAsLabel ? option.id : option.name} />
                                                <ListItemIcon>
                                                    <CardTypeIcon />
                                                </ListItemIcon>
                                            </>
                                        )}
                                    {(!cardTypeIcon && !option.icon) && (useIDAsLabel ? option.id : option.name)}
                                </MenuItem>
                            );
                        })}
                    </Select>
                    {isError ? (
                        <FormHelperText className={`desktop-helper-text ${isError ? 'error' : ''}`}>{errorMessage}</FormHelperText>
                    ) : (
                        ''
                    )}
                </FormControl>
            );
        } else {
            output = (
                <FormControl
                    className="full-width select-field-wrapper"
                    error={isError}
                >
                    {label && <InputLabel htmlFor={`select-${name}`} aria-label={`please select ${label}`}>{label}</InputLabel>}
                    <Select
                        name={name}
                        value={data[name]}
                        fullWidth
                        className={cardTypeIcon ? `${classes?.cardTypeIcon} select-wrapper` : 'select-wrapper'}
                        onChange={(event) => this.handleChange(event, '', onChangeHandler)}
                        onBlur={(event) => this.handleChange(event, '', onChangeHandler)}
                        error={isError}
                        inputProps={{
                            id: `select-${name}`,
                            classes: {
                                select: 'select-class',
                                root: 'select-root',
                                icon: 'select-icon',
                            },
                            'data-test': `account-select-field-${name}`,    // do NOT change or remove data-test attribute
                            'aria-labelledby': name,
                        }}
                        SelectDisplayProps={{
                            'data-test': `account-select-field-clickable-div-${name}`,    // do NOT change or remove data-test attribute
                        }}
                    >
                        {options.map((option) => {
                            const CardTypeIcon = option.icon;
                            return (
                                <MenuItem
                                    key={option.id}
                                    name={name}
                                    data-test={`${'my-account-field-'}${name}${'-value-'}${useIDAsLabel ? option.id : option.name}`}
                                    value={option.id}
                                    ContainerProps={{ name }}
                                    className={cardTypeIcon ? classes?.menuIcon : ''}
                                >
                                    {(cardTypeIcon && option.icon)
                                        && (
                                            <>
                                                <ListItemText primary={useIDAsLabel ? option.id : option.name} />
                                                <ListItemIcon>
                                                    <CardTypeIcon />
                                                </ListItemIcon>
                                            </>
                                        )}
                                    {(!cardTypeIcon && !option.icon) && (useIDAsLabel ? option.id : option.name)}
                                </MenuItem>
                            );
                        })}
                    </Select>
                    {isError ? (
                        <FormHelperText className={`form-helper-text ${isError ? 'error' : ''}`}>{errorMessage}</FormHelperText>
                    ) : (
                        ''
                    )}
                </FormControl>
            );
        }
        return output;
    }

    renderCheckbox(props) {
        const {
            isChecked,
            value,
            className = '',
            onChange,
            dataTest = null,
            label = '',
        } = props;
        const onChangeEvent = !onChange ? this.handleCheckboxChange : onChange;
        let dataTestField = null;
        if (dataTest) {
            dataTestField = { 'data-test': dataTest.field };
        }
        return (
            <FormControlLabel
                className={`checkbox-wrapper no-margin ${value}`}
                control={(
                    <Checkbox
                        checked={isChecked}
                        className={`checkbox-selecter ${className}`}
                        color="default"
                        // eslint-disable-next-line react/jsx-props-no-spreading
                        {...dataTestField}
                        onChange={(event) => onChangeEvent(event)}
                        value={value}
                        inputProps={{
                            'aria-labelledby': label,
                        }}
                    />
                )}
                label={label}
                aria-label={`please select ${label}`}
            />
        );
    }

    renderRecaptcha(name) {
        const { errors } = this.state;
        let errorMessage = ErrorLanguages(errors[name]);
        const isError = typeof errorMessage !== 'undefined';
        errorMessage = 'Please complete the Captcha to proceed.';
        // Set reCapcha key for localhost if it doesn't exist in the env file
        const APP_GOOGLE_RECAPCHA_KEY = mbpUtil.getEnv('APP_GOOGLE_RECAPCHA_KEY') ? mbpUtil.getEnv('APP_GOOGLE_RECAPCHA_KEY') : '6Le6ArEUAAAAANKfCmBmOEkIIWJVMuIUS926fonG';
        return (
            <>
                <ReCAPTCHA
                    defaultChecked
                    sitekey={APP_GOOGLE_RECAPCHA_KEY}
                    onChange={this.handleChangeRecap}
                    tabindex="0"
                    size="normal"
                />
                {isError ? (
                    <FormHelperText className={`form-helper-text ${isError ? 'recaptchaError' : ''}`}>{errorMessage}</FormHelperText>
                ) : (
                    ''
                )}
            </>
        );
    }

    render() {
        return null;
    }
}

export default Form;
